const routes = {
  getOrderDetails: '/proof-of-delivery/order',
  uploadFiles: '/proof-of-delivery/upload',
};

export default routes;